import {useEffect, useState} from "react";
import FunctionsData from "../../../Functions/FunctionsData";
import {Button, Drawer, FormControl, TextField,Stack} from "@mui/material";
import {Input} from "baseui/input";
import {LoadingButton} from "@mui/lab";
import {LanguageConfig} from "../../../Functions/LanguageConfig";
import * as React from "react";

export default function CampaignsAddCampaign ({currentData,mode,loading,setLoading,community,inspectors,outreach,active,setActive, isOpen, setIsOpen}) {

    const date = new Date();
    const [frmName, setFrmName] = useState(currentData.name || '');
    const [frmDesc, setFrmDesc] = useState(currentData.description || '');
    const [frmMerco, setFrmMerco] = useState(currentData.merco_id || '');
    const [frmDateFrom, setFrmDateFrom] = useState(new Date().toISOString().slice(0, 10));
    const [frmDateTo, setFrmDateTo] = useState(new Date(date.setMonth(date.getMonth()+1)).toISOString().slice(0, 10));
    const [updating,setUpdating] = useState(false);
    const [lng, setLng] = useState(currentData.lng || 0);
    const [lat, setLat] = useState(currentData.lat || 0);
    const [distance, setDistance] = useState(currentData.distance_community || 0);
    const [frmMaxVouchers,setFromMaxVouchers]=useState(currentData.max_vouchers||50);
    const [frmVouchersLeft,setFromVouchersLeft]=useState(currentData.vouchers_left);
    useEffect(() => {

        if (typeof currentData.start_date !== 'undefined') {
            setFrmDateFrom(currentData.start_date.slice(0, 10));
        }

        if (typeof currentData.end_date !== 'undefined') {
            setFrmDateTo(currentData.end_date.slice(0, 10));
        }

    }, [])

    async function submit() {

        setUpdating(true);
        const tkn = await FunctionsData.getCSRFToken();
        let requestOptionsVoucher = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'token': sessionStorage.sTkn,
                'X-CSRF-Token': tkn.csrf
            },
            body: JSON.stringify(
                {
                    name: frmName,
                    description: frmDesc,
                    merco_id: frmMerco,
                    start_date: frmDateFrom,
                    end_date: frmDateTo,
                    active: (mode === 'new') ? 1 : active,
                    campaign_target: (community) ? 'community' : (outreach ? 'outreach' : (inspectors ? 'inspectors' : 'public')),
                    max_vouchers:frmMaxVouchers,
                    lng:lng,
                    lat:lat,
                    distance_community:distance
                })
        };


        if (mode === "new") {
            await fetch(FunctionsData.getApiUrl("/api/campaign/"), requestOptionsVoucher)
                .then(response => response.json())
                .then(() => {
                    setLoading(true);
                    setIsOpen(false);
                })
        } else {
            await fetch(FunctionsData.getApiUrl("/api/campaign/") + (currentData.id || 0), requestOptionsVoucher)
                .then(response => response.json())
                .then((res) => {
                    //console.log('updated campaign', res);
                    setLoading(true);
                    setIsOpen(false);
                })
        }

    }

    function handleDayClick(e, fn) {
        fn(e.target.value)
    }

    return (
        <Drawer
            anchor={"right"}
            open={isOpen}
            autoFocus
            onClose={() => setIsOpen(false)}
        >

            <div style={{padding:20}}>
                <h1>{(mode === 'new') ? "Add a new campaign" : "Modify an existing campaign"}</h1>
                <div style={{marginTop: 20}}>
                    <FormControl fullWidth sx={{marginBottom: 2}}>
                        <TextField
                            error={frmName === ''}
                            label={"Campaign name"}
                            type="text"
                            aria-describedby="component-helper-text"
                            value={frmName}
                            onChange={(e) => setFrmName(e.target.value)}
                            focused
                        />
                    </FormControl>
                    <FormControl fullWidth sx={{marginBottom: 2}}>
                        <TextField
                            error={frmName === ''}
                            label={"Campaign description"}
                            type="text"
                            aria-describedby="component-helper-text"
                            value={frmDesc}
                            onChange={(e) => setFrmDesc(e.target.value)}
                            focused
                            multiline
                            rows={5}
                        />
                    </FormControl>
                    <FormControl fullWidth sx={{marginBottom: 2}}>
                        <TextField
                            error={frmMerco === ''}
                            label="Merco ID"
                            type="text"
                            aria-describedby="component-helper-text"
                            value={frmMerco}
                            onChange={(e) => setFrmMerco(e.target.value)}
                            focused
                        />
                    </FormControl>
                    <h3>Campaign start</h3>
                    <FormControl fullWidth sx={{marginBottom: 2}}>
                        <Input error={frmDateFrom === ''} type={"date"} value={frmDateFrom} onChange={(e) => handleDayClick(e, setFrmDateFrom)}/>
                    </FormControl>
                    <h3>Campaign end</h3>
                    <FormControl fullWidth sx={{marginBottom: 2}}>
                        <Input error={frmDateTo === ''} type={"date"} value={frmDateTo} onChange={(e) => handleDayClick(e, setFrmDateTo)}/>
                    </FormControl>
                    {
                        (community === true || inspectors === true || outreach === true) ?
                            <>
                                <FormControl fullWidth sx={{marginBottom: 2}}>
                                    <TextField
                                        error={lng === 0}
                                        label="Longitude (X)"
                                        type="text"
                                        aria-describedby="component-helper-text"
                                        value={lng}
                                        onChange={(e) => setLng(e.target.value)}
                                        focused
                                    />
                                </FormControl>
                                <FormControl fullWidth sx={{marginBottom: 2}}>
                                    <TextField
                                        error={lat === 0}
                                        label="Latitude (Y)"
                                        type="text"
                                        aria-describedby="component-helper-text"
                                        value={lat}
                                        onChange={(e) => setLat(e.target.value)}
                                        focused
                                    />
                                </FormControl>
                                <FormControl fullWidth sx={{marginBottom: 2}}>
                                    <TextField
                                        error={distance === 0}
                                        label="Distance allowed from center in km"
                                        type="number"
                                        pattern="[0-9]+" inputMode="numeric"
                                        aria-describedby="component-helper-text"
                                        value={distance}
                                        onChange={(e) => setDistance(e.target.value)}
                                        focused
                                    />
                                </FormControl>
                           
                            </>
                            : null
                    }

                    <LoadingButton
                        loading={updating}
                        variant={"contained"}
                        disabled={(frmName === '' || frmMerco === '' || frmDateTo === '' || frmDateFrom === '')}
                        onClick={submit}
                    >
                        Save campaign
                    </LoadingButton>
                    <Button variant={""} sx={{marginLeft: 1}} onClick={() => setIsOpen(false)}>Cancel</Button>
                </div>
            </div>
        </Drawer>
    );
}
